import { useEffect, useState } from "react";
import { Chip } from "@mui/material";
import AedasLoading from "../../Components/Shared/AedasLoading/AedasLoading";
import DetailView, { DetailCard, DetailField, emailValue, formatDate, text } from "../../Components/Shared/DetailView/DetailView";
import { getEmployee } from "../../Service/EmployeeService/EmployeeService";
import { handleApiError } from "../../Utils/apiErrors";
import { permissionLabel } from "../../Utils/permissionsUtils";
import { fullName, isActive } from "./userUtils";

// Ficha de un usuario (GET /employee/{id}) con sus permisos efectivos, de solo lectura
export default function UserDetail(props: { employeeId: number; onNotFound: () => void }) {
  const { employeeId, onNotFound } = props;
  const [employee, setEmployee] = useState<any>(null);

  useEffect(() => {
    let active = true;
    getEmployee(employeeId)
      .then((response) => {
        if (active) setEmployee(response.data);
      })
      .catch((error) => {
        if (active) handleApiError(error, { fallback: "No se ha podido cargar el usuario", onNotFound });
      });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId]);

  if (!employee) return <AedasLoading />;

  const permissions: any[] = employee.permissions ?? [];

  return (
    <div className="detailView">
      <DetailView
        title={fullName(employee)}
        description={employee.email}
        badges={
          <>
            {employee.rol_name ? <Chip size="small" color="info" label={employee.rol_name} /> : null}
            <Chip
              size="small"
              color={isActive(employee) ? "success" : "default"}
              label={isActive(employee) ? "Activo" : "Inactivo"}
            />
          </>
        }
      >
        <DetailCard title="Datos personales">
          <DetailField label="Nombre">{text(employee.name)}</DetailField>
          <DetailField label="Apellidos">{text(employee.surname)}</DetailField>
          <DetailField label="Nombre visible">{text(employee.display_name)}</DetailField>
          <DetailField label="Email">{emailValue(employee.email)}</DetailField>
          <DetailField label="Teléfono">{text(employee.telephone)}</DetailField>
        </DetailCard>

        <DetailCard title="Acceso">
          <DetailField label="Rol">{text(employee.rol_name)}</DetailField>
          <DetailField label="Estado">{isActive(employee) ? "Activo" : "Inactivo"}</DetailField>
          <DetailField label="Id de Azure">{text(employee.id_azure)}</DetailField>
          <DetailField label="Rol de Azure">{text(employee.azure_rol)}</DetailField>
          <DetailField label="Delegación provincial">{text(employee.delegacion_provincial)}</DetailField>
        </DetailCard>

        <DetailCard title="Registro">
          <DetailField label="Alta">{formatDate(employee.created_at)}</DetailField>
          <DetailField label="Última modificación">{formatDate(employee.updated_at)}</DetailField>
        </DetailCard>
      </DetailView>

      <section className="detailSection">
        <h3 className="detailSectionTitle">Permisos efectivos</h3>
        <div className="chipList">
          {permissions.length === 0 ? (
            <span className="cellEmpty">Sin permisos</span>
          ) : (
            permissions.map((permission) => (
              <Chip key={permission.id ?? permission.name} size="small" label={permissionLabel(permission.name)} />
            ))
          )}
        </div>
      </section>
    </div>
  );
}
